<span class="hand" (click)="open()"> {{ translate | translate: { number: log.sprint.number } }}</span>
